import { ModalContext } from '@/contexts/ModalProvider.jsx';
import { beginCheckout, getProductsCartInfo, viewCart } from '@/utils/analytics.js';
import React, { useState, useEffect, useContext } from 'react';
import cn from 'classnames';
import { isUndefined } from 'lodash';
import Router, { useRouter } from 'next/router';
import {
  Heading,
  HeadingEnum,
  BoldEnum,
  FullPageCartPage,
  WaveBreadCrumb,
  TextColorEnum,
  CartIcon,
  Discount,
  ArrowBack,
  SnackBar,
} from '@desquared/wave-components-library';
import isEqual from 'lodash/isEqual';
import ReplacementSheet from '../ReplacementSheet/ReplacementSheet';
import { cartPrice, productsForOrder, fullCartStore } from '@/store/cart';
import { ReplacementSheetStore, ReplacementOptionStore, PaymentOptionStore } from '@/store/sideSheet';
import User from '@/store/user';
import GuestUserStore from '@/store/guestUser';
import { chargesBreakdownStore, discountsBreakdownStore } from '@/store/priceBreakdown';
import { ListAdditionSheetStore } from '@/store/sideSheet';
import { groupProductsByCategoryCart } from '@/utils/category';
import {
  checkOrder,
  removeAll,
  getFullCart,
  onAdd,
  onRemove,
  setCartProducts,
  setDiscounts,
  onRemoveAll,
  updateCartOrder,
} from '@/utils/products/products';
import { addGiftsToFullPageCart } from '@/utils/cart';
import { openListSideSheet, openProductDetails } from '@/utils/products';
import { setLayout } from './useCartBanner';
import styles from './FullPageCart.module.css';
import useWindowUnderThreshold from '@/hooks/useWindowUnderThreshold';
import { DeliveryServicesContext } from '@/contexts/DeliveryServicesContext';
import useBundleOffersSummary from '@/hooks/useBundleOffersSummary';
import { ListSelectedProductStore } from '@/store/listSelectedProduct';
import { useTranslations } from 'next-intl';
import { PostalCode } from '@/store/isAddressRegistered';
import {
  EXACT_DATE_TIMESLOT_TOKEN,
  PREDICTION_TIMESLOT_TOKEN,
  createPredictiveTimeslotTextWithDate,
  fetchTimeslotsDelivery,
} from '@/utils/logic/timeslots';
import getLayoutProps from '@/utils/layout/layout';
import { CurrencyContext } from '@/contexts/CurrencyProvider';
import { getPaymentMethods } from '@/utils/getConfiguration';
import { mockCheckoutData } from '@/mocks/fullPageCartMocks';
import { useSessionId } from '@/hooks/useSessionId';
import isBoolean from 'lodash/isBoolean';
import Link from 'next/link';

export default function FullPageCart(props) {
  const t = useTranslations('full_page_cart');
  const r = useTranslations('common');
  const router = useRouter();
  const { openActionModal, close } = useContext(ModalContext);
  const [minOrderImage, setMinOrderImage] = useState();
  const [formattedTitle, setFormatedTitle] = useState();
  const isMobile = useWindowUnderThreshold(850);
  const breadCrumbItems = [
    { title: t('back'), link: router.locale === router.defaultLocale ? '/categories' : `/${router.locale}/categories` },
  ];
  const [priceCart, setCartPrice] = useState(cartPrice.getValue() ? cartPrice.getValue() : 0);
  const [tempProducts, setTempProducts] = useState([]);
  const [replacementOption, setReplacementOption] = useState(ReplacementOptionStore.getValue());
  const [order, setOrder] = useState(fullCartStore.getValue()?.data?.order);
  const [showSnackBar, setShowSnackbar] = useState(false);
  const [categories, setCategories] = useState([]);
  const [breakdownCategories, setBreakdownCategories] = useState([]);
  const [remove, setRemove] = useState(false);
  const [shippingCost, setShippingCost] = useState(0);
  const [productsForOrderLength, setProductsForOrderLength] = useState(0);
  const { bundleOffersSummary } = useBundleOffersSummary();
  const [listAddtion, setListAddition] = useState(ListSelectedProductStore.getValue());
  const [finalSum, setFinalSum] = useState('');
  const [disabled, setDisabled] = useState(false);
  const { getCollectionTypes, selectedUserAddressIndex, selectedService } = useContext(DeliveryServicesContext);
  const [productsLength, setProductsLength] = useState(0);
  const [collectionType, setCollectionType] = useState(getCollectionTypes());
  const [hasPredictiveTimeslot, setHasPredictiveTimeSlot] = useState(false);
  const [predictiveTimeslotText, setPredictiveTimeslotText] = useState(['', '']);
  const [listAddtionItem, setListAdditionItem] = useState();
  const [emoji, setEmoji] = useState(false);
  const { formatter } = useContext(CurrencyContext);
  const sessionId = useSessionId();

  const element = setLayout(props.cart, 0, isMobile, props.defaultProductImage, sessionId);
  const sliderProducts = setLayout(props.sliderProducts, 1, isMobile, props.defaultProductImage);

  const removeAllTogether = () => {
    removeAll();
    updateCartOrder([], replacementOption.option, true, t('no_comment'));
    Router.push('/categories', '/categories');
    cartPrice.update((0).toFixed(2));
  };
  const createCart = () => {
    let allProducts = tempProducts;

    const { giftQuantitiess, newAllProducts } = addGiftsToFullPageCart(
      fullCartStore.getValue()?.data,
      allProducts,
      bundleOffersSummary,
      t('no_comment')
    );
    const groupedProducts = groupProductsByCategoryCart(newAllProducts ?? allProducts);

    const products = fullCartStore.getValue()?.data?.products || fullCartStore.getValue()?.products;

    setCategories(
      getFullCart(
        groupedProducts,
        fullCartStore.getValue()?.data?.order,
        products,
        setTempProducts,
        setRemove,
        remove,
        fullCartStore.getValue().data?.potentialDiscounts,
        bundleOffersSummary,
        giftQuantitiess,
        router.locale,
        t('no_comment'),
        formatter
      )
    );
  };

  const hasRecommendedProducts = sliderProducts => {
    return (
      sliderProducts?.data?.[0]?.content?.products_andor_offers?.length > 0 &&
      !sliderProducts.data[0].content.products_andor_offers.every(prod => prod === null)
    );
  };

  useEffect(() => {
    const $Postal = PostalCode.subscribe(async postalCode => {
      if (!selectedService) return;
      const res = await fetchTimeslotsDelivery(postalCode, true, () => {}, selectedService.id);

      if (res.type === PREDICTION_TIMESLOT_TOKEN) {
        setHasPredictiveTimeSlot(true);
        setPredictiveTimeslotText(
          createPredictiveTimeslotTextWithDate(res.prediction, t('delivery_keyword'), router.locale)
        );
      }

      if (res.type === EXACT_DATE_TIMESLOT_TOKEN) {
        setHasPredictiveTimeSlot(false);
        setPredictiveTimeslotText(['', '']);
      }
    });

    return () => {
      $Postal.unsubscribe();
    };
  }, [selectedService, router.locale, setHasPredictiveTimeSlot, setPredictiveTimeslotText, t]);

  useEffect(() => {
    if (isBoolean(listAddtionItem)) {
      setCollectionType(getCollectionTypes());
      const productsForOrder$ = productsForOrder.subscribe((productsOrder = []) => {
        const tempProductsFiltered = setCartProducts(productsOrder);
        setProductsForOrderLength(productsOrder.length);

        setTempProducts(prevProducts => {
          // Only update state if there are changes to prevent unnecessary re-renders
          if (!isEqual(prevProducts, tempProductsFiltered) || productsOrder.length !== prevProducts.length) {
            return tempProductsFiltered;
          }
          return prevProducts;
        });
      });

      return () => {
        productsForOrder$.unsubscribe();
      };
    }
  }, [selectedService, listAddtionItem]);

  useEffect(() => {
    const cartPrice$ = cartPrice.subscribe(setCartPrice);
    const ReplacementOptionStore$ = ReplacementOptionStore.subscribe(setReplacementOption);
    const ListAddtionStore$ = ListSelectedProductStore.subscribe(setListAddition);
    async function getProps() {
      const layoutProps = await getLayoutProps({ headerProps: { selectedIndex: -1 } }, Router.locale);
      const imageMin = layoutProps?.emptyStates?.minimum_order_value?.url
        ? layoutProps?.emptyStates?.minimum_order_value?.url
        : null;
      setMinOrderImage(imageMin);
    }
    getProps();
    const $listAddition = ListAdditionSheetStore.subscribe(setListAdditionItem);

    return () => {
      cartPrice$.unsubscribe();
      $listAddition.unsubscribe();
      ReplacementOptionStore$.unsubscribe();
      ListAddtionStore$.unsubscribe();
    };
  }, []);

  useEffect(() => {
    if (tempProducts?.length > 0 && collectionType?.length > 0) {
      callCart(tempProducts, false);
    }
  }, [remove, listAddtion, formatter, collectionType, tempProducts]);

  const callCart = (products, flag) => {
    checkOrder(
      products,
      replacementOption.option,
      flag,
      collectionType?.length > 0 ? collectionType : [process.env.defaultCollectionType],
      selectedUserAddressIndex,
      bundleOffersSummary,
      false,
      [],
      undefined,
      undefined,
      t('no_comment'),
      formatter
    ).then(result => {
      if (result && result.data) {
        setOrder(result?.data?.order);
        setEmoji(result?.data?.messages?.some(el => el.code === 'MSG_ORDER00017'));
        setProductsLength(result?.data?.products?.length ?? 0);
        fullCartStore.update(result);
        if (result?.progress) {
          const { title, data } = result?.progress;
          if (data?.remainingAmountForFree) {
            setFormatedTitle(
              title
                .replace('{remainingAmountForFree}', data.remainingAmountForFree.toFixed(2))
                .replace('{currency}', data.currency)
            );
          } else {
            setFormatedTitle(
              title.replace('{remainingAmount}', data.remainingAmount).replace('{currency}', data.currency)
            );
          }
        }

        const shipping = result?.data?.order?.fees?.some(el => el.type === 'SHIPPING_COST')
          ? result?.data?.order?.fees?.filter(el => el.type === 'SHIPPING_COST')[0]?.amount / 100
          : 0;
        setShippingCost(
          result?.data?.order?.fees?.some(el => el.type === 'SHIPPING_COST')
            ? result?.data?.order?.fees?.filter(el => el.type === 'SHIPPING_COST')[0]?.amount / 100
            : 0
        );

        let newPrice = result?.data?.order?.orderItemsPriceWithoutDiscounts;
        if (result.data?.order?.discounts?.length > 0) {
          let disc = [];
          if (setDiscounts(result?.data?.order?.discounts, 'PRODUCTS') > 0) {
            newPrice = newPrice - setDiscounts(result?.data?.order?.discounts, 'PRODUCTS');
            disc.push({
              description: t('product_discounts_title'),
              value: '- ' + formatter.format(setDiscounts(result?.data?.order?.discounts, 'PRODUCTS') / 100),
              dataRowType: 'DataRowInformation',
            });
          }
          if (setDiscounts(result?.data?.order?.discounts, 'WHOLE_CART') > 0) {
            newPrice = newPrice - setDiscounts(result?.data?.order?.discounts, 'WHOLE_CART');
            disc.push({
              description: t('campaigns'),
              value: '- ' + formatter.format(setDiscounts(result?.data?.order?.discounts, ' WHOLE_CART') / 100),
              dataRowType: 'DataRowInformation',
            });
          }
          discountsBreakdownStore.update(disc);
          let charg = [
            {
              description: t('product_value_title'),
              value: formatter.format(result?.data?.order?.orderItemsPriceWithoutDiscounts / 100),
              dataRowType: 'DataRowInformation',
            },
            {
              description:
                result?.data?.order?.fees?.filter(el => el.type === 'SHIPPING_COST')[0]?.title ?? t('shipping_title'),
              value: result?.data?.order?.fees?.some(el => el.type === 'SHIPPING_COST')
                ? formatter.format(
                    result?.data?.order?.fees?.filter(el => el.type === 'SHIPPING_COST')[0]?.amount / 100
                  )
                : formatter.format(0),
              dataRowType: 'DataRowInformation',
            },
          ];
          chargesBreakdownStore.update(charg);
        } else {
          let charg = [
            {
              description: t('product_value_title'),
              value: formatter.format(result?.data?.order?.orderItemsPrice / 100),
              dataRowType: 'DataRowInformation',
            },
            {
              description:
                result?.data?.order?.fees?.filter(el => el.type === 'SHIPPING_COST')[0]?.title ?? t('shipping_title'),
              value: result?.data?.order?.fees?.some(el => el.type === 'SHIPPING_COST')
                ? formatter.format(
                    result?.data?.order?.fees?.filter(el => el.type === 'SHIPPING_COST')[0]?.amount / 100
                  )
                : formatter.format(0),
              dataRowType: 'DataRowInformation',
            },
          ];
          chargesBreakdownStore.update(charg);
          discountsBreakdownStore.update([]);
        }
        if (result.data?.order?.discounts?.length > 0) {
          setBreakdownCategories([
            {
              headerTitle: t('charges_title'),
              headerIcon: CartIcon,
              items: chargesBreakdownStore.getValue(),
            },
            {
              headerTitle: t('discounts_title'),
              headerIcon: Discount,
              items: discountsBreakdownStore.getValue(),
            },
          ]);
        } else {
          setBreakdownCategories([
            {
              headerTitle: t('charges_category_title'),
              headerIcon: CartIcon,
              items: chargesBreakdownStore.getValue(),
            },
          ]);
        }
        updateCartOrder(tempProducts, replacementOption.option, false, t('no_comment'));
        createCart();
        if (result.data?.messages?.length > 0) {
          //setDisabled(result.data?.messages.some(el => el.code === 'MSG_ORDER00017'));
        } else if (disabled) {
          setDisabled(false);
        }

        if (tempProducts.length > 0) {
          viewCart(getProductsCartInfo(products || []), Math.round(newPrice / 100 + shipping));
        }

        setCartPrice(formatter.format(newPrice / 100 + shipping));

        setFinalSum(formatter.format(newPrice / 100 + shipping));
      }
    });
  };

  const showMinimumLimitModal = minOrderLimit => {
    const url = minOrderImage ? minOrderImage : '/assets/wave-grocery/Bus.png';
    openActionModal({
      closeOnOuterClick: true,
      title: t('order_minimum_limit_title'),
      text: t('order_minimum_limit_description', { limit: minOrderLimit }),
      actions: [
        {
          btnLabel: t('return_to_cart'),
          onClick: () => {
            close();
          },
        },
      ],
      img: {
        url: url,
        ariaLabel: t('time_run_out_title'),
        size: 'medium',
      },
    });
  };

  function onSubmit() {
    const paymentDropdownOptions = getPaymentMethods('') ?? mockCheckoutData.methods;
    PaymentOptionStore.update(paymentDropdownOptions[0]);
    checkOrder(
      tempProducts,
      replacementOption.option,
      false,
      collectionType,
      selectedUserAddressIndex,
      bundleOffersSummary,
      false,
      [],
      undefined,
      undefined,
      t('no_comment'),
      formatter
    ).then(result => {
      if (result?.data?.messages?.some(el => el.code === 'MSG_ORDER00017')) {
        showMinimumLimitModal(result?.progress.progressInfo.requiredValue / 100);
        updateCartOrder(tempProducts, replacementOption.option, false, t('no_comment'));
        return;
      }

      if (result && result.data) {
        updateCartOrder(tempProducts, replacementOption.option, false, t('no_comment'));
        fullCartStore.update(result);
        const user = User.getValue();
        const guestUser = GuestUserStore.getValue();

        if (tempProducts.length > 0) {
          const shipping = result?.data?.order?.fees?.some(el => el.type === 'SHIPPING_COST')
            ? result?.data?.order?.fees?.filter(el => el.type === 'SHIPPING_COST')[0]?.amount / 100
            : 0;
          beginCheckout(getProductsCartInfo(tempProducts || []), Math.round(finalSum / 100 + shipping));
        }

        if (guestUser?.address || guestUser?.takeAway) {
          Router.push('/checkout', '/checkout');
          return;
        }

        if (!user?._id) {
          Router.push('/login', '/login');
          return;
        }
        if (User.getValue()?.address?.length === 0) {
          IsAddressModalOpen.update('open');
          return;
        }

        Router.push('/checkout', '/checkout');
      }
    });
  }
  return (
    <div className={cn(styles.container)}>
      <div className={cn(styles.titles)}>
        <WaveBreadCrumb
          hasFirstArrow={false}
          items={breadCrumbItems}
          lastElementClickable={true}
          hasFirstIcon={true}
          FirstIcon={ArrowBack}
          LinkComponent={Link}
        />
        <div className={cn(styles.titleSubtitle)}>
          <Heading color={TextColorEnum.OnSurfaceHighEmphasis} type={HeadingEnum.HeadingL} bold={BoldEnum.Bold}>
            {t('page_title')}
          </Heading>
        </div>
      </div>
      <FullPageCartPage
        headerTitle={t('title', { count: productsLength })}
        headerPriceTitle={t('price_breakdown_title')}
        buttonLabel={t('complete_btn_label')}
        categories={breakdownCategories?.length > 0 ? breakdownCategories : []}
        finalSumDescription={t('final_sum_title')}
        finalSumValue={finalSum}
        replacementsSubtitle={replacementOption.title}
        replacementsTitle={t('replacements_title')}
        footerAddText={t('footer_add')}
        footerDeleteText={t('footer_delete')}
        cartCategories={categories}
        title={''}
        replacementClick={() => {
          ReplacementSheetStore.open();
        }}
        replacementOption={replacementOption.option}
        onSubmit={onSubmit}
        removeAll={() => removeAllTogether()}
        onChange={(id, ingredients) => {
          onAdd(id, setTempProducts, setRemove, remove, fullCartStore.getValue(), undefined, ingredients);
        }}
        onRemove={(id, ingredients) => {
          onRemove(id, setTempProducts, setRemove, remove, undefined, undefined, ingredients);
        }}
        onAddList={openListSideSheet}
        onListAdd={() => openListSideSheet(tempProducts)}
        disabled={disabled}
        onOpenDetails={item => openProductDetails(item)}
        listIcon={process.env.listIcon}
        setMaxSnackBar={setShowSnackbar}
        hasPredictiveTimeslot={hasPredictiveTimeslot}
        predictiveTimeslotText={predictiveTimeslotText}
        listButtonText={r('lists_tile_item')}
        removeButtonText={r('remove_all_tile_item')}
        removeAllInstance={(id, ingredients) => {
          onRemoveAll(id, setTempProducts, setRemove, remove, undefined, undefined, ingredients);
        }}
        progressBarEmoji={emoji ? '🙄' : '🚚'}
        hasProgressBar={!isUndefined(fullCartStore.getValue()?.progress)}
        progressBarDescription={!isUndefined(fullCartStore.getValue()?.progress) && formattedTitle}
        progressBarProgress={
          (fullCartStore.getValue()?.progress?.progressInfo?.currentValue * 100) /
          fullCartStore.getValue()?.progress?.progressInfo?.requiredValue
        }
        defaultProductImage={props.defaultProductImage}
      >
        {element}
      </FullPageCartPage>
      <SnackBar open={showSnackBar} setOpen={setShowSnackbar} text={t('snackbar')} position={'center'} />
      <ReplacementSheet />
      {hasRecommendedProducts(props.sliderProducts) && <div className={styles.slider}>{sliderProducts}</div>}
    </div>
  );
}
